/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react"
import MaskedInput from "react-maskedinput"
import { CircularProgress } from "@material-ui/core"
import Select from "react-select"

import { i18n } from "../../../translate/i18n"

import "./style.css"
import { getRequest } from "utils/request"
import { useModal } from "hooks/modal"
import { tzList } from "utils/timezoneList"
import { postRequest } from "utils/request"

class Company {
  name = ""
  nickName = ""
  CompanyCategoryId = ""
  site = null
  document = ""
  responsibleName = ""
  responsibleEmail = ""
  responsibleCellPhone = ""
  timeZone = ""
  openIntegration = ""
}

export default function TabNewCompany({ history }) {
  const [company, setCompany] = useState(new Company())
  const [listcategory, setListCategory] = useState([])
  const [skute, setSkute] = useState("")
  const [listchannels, setListChannels] = useState([])
  const [channels, setChannels] = useState([])
  const [loading, setLoading] = useState(false)
  const [openIntegration, setOpenIntegration] = useState(false)
  const { toggleHelperId } = useModal()

  const loadInfos = async () => {
    setLoading(true)

    //BUSCA CANAIS DISPONIVEIS
    const ReturnGet = await getRequest(`/channels`)

    if (ReturnGet.success) {
      let opt = []

      ReturnGet.data
        .filter((w) => w.id !== 3)
        .map((data) => {
          // DIFERENTE DE 3 - SKUTE
          opt.push({ value: data.id, label: data.description })
        })
      setListChannels(opt)
    }

    //BUSCA CATEGORIAS DISPONIVEIS
    const ReturnGet2 = await getRequest(
      `/companiescategories?text=&offset=${0}&limit=${9999}`
    )

    if (ReturnGet2.success) {
      setListCategory(ReturnGet2.data)
      setLoading(false)
    }
  }

  useEffect(() => {
    loadInfos()
    toggleHelperId(22)
  }, [])

  const handleNewCompany = async () => {
    setLoading(true)

    const idchannels = []
    channels.map((data) => {
      idchannels.push(data.value)
    })

    //CRIAR NOVA EMPRESA
    const ReturnPost = await postRequest(`/companies`, {
      name: company.name,
      nickName: company.nickName,
      CompanyCategoryId: company.categoryId,
      site: company.site,
      document: company.document,
      responsibleName: company.responsibleName,
      responsibleEmail: company.responsibleEmail,
      responsibleCellPhone: company.responsibleCellPhone,
      Channels: idchannels,
      skute: Number(skute),
      timeZone: company.timeZone,
      openIntegration: company.openIntegration,
    })

    if (ReturnPost.success) {
      setLoading(false)
      history.push(`../../../../dashboard/editcompany/${ReturnPost.data.id}`)
    }

    setLoading(false)
  }

  const handleChangeChannels = (e) => {
    setChannels([])

    if (e != null) {
      // console.log(e);
      setChannels(e)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCompany({ ...company, [name]: value })
  }

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="container-card">
        <form
          className="form-edit"
          onSubmit={(e) => {
            e.preventDefault()
            handleNewCompany()
          }}
        >
          <h4 className="header-title">{i18n.t("newCompany")}</h4>

          <div className="form-row">
            <div className="form-group col-md-5">
              <label>{i18n.t("socialReason")} *</label>
              <input
                type="text"
                className="form-control"
                value={company.name}
                maxLength={100}
                name="name"
                required
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group col-md-5">
              <label> {i18n.t("fantasy")} *</label>
              <input
                type="text"
                className="form-control"
                maxLength={100}
                name="nickName"
                required
                value={company.nickName}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-3">
              <label> {i18n.t("registry")} *</label>
              <MaskedInput
                mask="11.111.111/1111-11"
                type="text"
                className="form-control"
                data-toggle="input-mask"
                data-mask-format="00.000.000/0000-00"
                data-reverse="true"
                maxLength="18"
                minLength="18"
                name="document"
                required
                value={company.document}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-3">
              <label> {i18n.t("site")}</label>
              <input
                type="text"
                maxLength={255}
                name="site"
                className="form-control"
                value={company.site}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-2">
              <label> {i18n.t("category")} *</label>
              <select
                className="form-control select2"
                data-toggle="select2"
                value={company.categoryId}
                name="categoryId"
                required
                onChange={handleInputChange}
              >
                <option value="">{i18n.t("select")}</option>
                {listcategory.map((data, index) => (
                  <option key={index} value={data.id}>
                    {data.description}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-2">
              <label> {i18n.t("timeZone")} *</label>
              <select
                className="form-control select2"
                data-toggle="select2"
                value={company.timeZone}
                name="timeZone"
                required
                onChange={handleInputChange}
              >
                <option value="">{i18n.t("select")}</option>
                {tzList.map((data, index) => (
                  <option key={index} value={data.value}>
                    {data.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <h4 style={{ marginTop: 10 }} className="header-title">
            {i18n.t("contact")}
          </h4>

          <div className="form-row">
            <div className="form-group col-md-3">
              <label> {i18n.t("responsible")} *</label>
              <input
                type="text"
                maxLength={100}
                className="form-control"
                required
                name="responsibleName"
                value={company.responsibleName}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group col-md-3">
              <label>{i18n.t("phone")} *</label>
              <MaskedInput
                mask="(11) 11111-1111"
                type="text"
                className="form-control"
                data-toggle="input-mask"
                data-mask-format="(00) 00000-0000"
                maxLength="15"
                minLength="14"
                name="responsibleCellPhone"
                required
                value={company.responsibleCellPhone}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t("email")} *</label>
              <input
                type="text"
                className="form-control"
                maxLength={100}
                name="responsibleEmail"
                required
                value={company.responsibleEmail}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-4">
              <label> Skute *</label>
              <select
                className="form-control select2"
                data-toggle="select2"
                value={skute}
                required
                onChange={(value) => setSkute(value.target.value)}
              >
                <option value="">{i18n.t("select")}</option>
                <option value="1">{i18n.t("partner")}</option>
                <option value="2">{i18n.t("noPartner")}</option>
                <option value="3">{i18n.t("noBelong")}</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>{i18n.t("channel")}</label>
              <Select
                options={listchannels}
                placeholder={`Selecione os canais`}
                isMulti={true}
                getStyles="select2 form-control select2-multiple"
                value={channels}
                onChange={handleChangeChannels}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-2 checkbox-openIntegration">
              <input
                checked={openIntegration}
                onClick={() => setOpenIntegration(!openIntegration)}
                type="checkbox"
              />
              <label style={{ marginLeft: 10 }}>
                {i18n.t("openIntegration")}
              </label>
            </div>
            {openIntegration && (
              <div className="form-group col-md-2">
                <label>{i18n.t("informSystem")} *</label>
                <input
                  type="text"
                  className="form-control"
                  maxLength={100}
                  name="openIntegration"
                  required
                  value={company.openIntegration}
                  onChange={handleInputChange}
                />
              </div>
            )}
          </div>

          <div
            className="button-list mt-3 pull-right"
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              marginRight: 30,
              marginBottom: 5,
            }}
          >
            {!loading ? (
              <>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => history.push(`../../dashboard/company`)}
                >
                  <i i className="mdi mdi-backup-restore"></i>
                  {i18n.t("getBack")}
                </button>
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                  {i18n.t("save")}
                </button>{" "}
              </>
            ) : (
              <div className="area-loading-new-company">
                <CircularProgress />
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}
